/**
 * Created by Andrey Popov on 10.11.20
 */

const LayerManager = function () {
    this.hiddenLayers = new Set();
    this.reset();

    this.onRebuild = function () {};

    this.rebuildLayers();
};

LayerManager.prototype.getLayersCount = function () {
    return this.layers.length;
};

LayerManager.prototype.rebuildLayers = function () {
    const cards = Game.currentGame.table.cards.slice();
    const previousLayersCount = this.layers.length;

    this.layers = [];

    while (cards.length > 0) {
        const bottomCards = [];

        for (let i = 0; i < cards.length; i++) {
            let isBottomCard = true;
            for (let j = 0; j < cards.length; j++) {
                if (i === j) {
                    continue;
                }

                if (cards[i].overlaps(cards[j]) && i > j) {
                    isBottomCard = false;
                    break;
                }
            }

            if (isBottomCard) {
                bottomCards.push(cards[i]);
            }
        }

        this.layers.push(bottomCards);
        bottomCards.forEach((bottomCard) => {
            const index = cards.indexOf(bottomCard);
            cards.splice(index, 1);
        });
    }

    this.layerIndex = Math.min(this.layerIndex, Math.max(0, this.layers.length - 1));

    this.updateHiddenLayers(previousLayersCount);

    this.onRebuild(this.layers.length);
};

LayerManager.prototype.updateHiddenLayers = function (previousLayersCount) {
    this.hiddenLayers.forEach((layer) => {
        if (layer >= this.layers.length) {
            this.hiddenLayers.delete(layer);
        }
    });

    if (this.hiddenLayers.has(previousLayersCount - 1)) {
        for (let layer = previousLayersCount; layer < this.layers.length; layer++) {
            this.hiddenLayers.add(layer);
        }
    }
};

LayerManager.prototype.isCardActive = function (card) {
    for (let i = 0; i <= this.layerIndex; i++) {
        if (this.layers[i] && this.layers[i].indexOf(card) !== -1) {
            return this.isLayerVisible(i);
        }
    }

    return false;
};

LayerManager.prototype.isCardBelowActiveLayer = function (card) {
    return this.layers.some((layer, index) => index < this.layerIndex && layer.includes(card));
};

LayerManager.prototype.selectLayer = function (layerIndex) {
    this.layerIndex = layerIndex;
};

LayerManager.prototype.isLayerVisible = function (layerIndex) {
    return !this.hiddenLayers.has(layerIndex);
};

LayerManager.prototype.isCardVisible = function (card) {
    const layerIndex = this.layers.findIndex((layer) => layer.indexOf(card) !== -1);
    return this.isLayerVisible(layerIndex);
};

LayerManager.prototype.setLayerVisible = function (layerIndex, visible) {
    if (visible) {
        this.hiddenLayers.delete(layerIndex);
    } else {
        this.hiddenLayers.add(layerIndex);
    }
};

LayerManager.prototype.resetVisibility = function () {
    this.hiddenLayers.clear();
};

LayerManager.prototype.reset = function () {
    this.resetVisibility();
    this.layerIndex = 0;
    this.layers = [];
};